import { FormlyFieldConfig } from '@ngx-formly/core';

export function selectReadonlyExtension(field: FormlyFieldConfig) {
  field.props = field.props || {};
  field.hooks = field.hooks || {};

  const originalTabindex = field.props.tabindex;

  const existingOnInit = field.hooks.onInit;
  field.hooks.onInit = (f: FormlyFieldConfig) => {
    if (existingOnInit) {
      existingOnInit(f);
    }

    const currentReadonly = !!f.props?.readonly;
    (f as any)['_prevReadonly'] = currentReadonly;
    updateReadonlyState(f, currentReadonly, originalTabindex);

    if (f.options && f.options.fieldChanges) {
      f.options.fieldChanges.subscribe(({ field: changedField, type }) => {
        if (type === 'expressionChanges' && changedField === f) {
          const isReadonlyNow = !!f.props?.readonly;
          if ((f as any)['_prevReadonly'] !== isReadonlyNow) {
            (f as any)['_prevReadonly'] = isReadonlyNow;
            updateReadonlyState(f, isReadonlyNow, originalTabindex);
          }
        }
      });
    }
  };
}

function updateReadonlyState(
  field: FormlyFieldConfig,
  isReadonly: boolean,
  originalTabindex: number | undefined
) {
  field.props = field.props || {};
  field.props.attributes = field.props.attributes || {};

  if (isReadonly) {
    if (!field.className?.includes('formly-readonly-field')) {
      field.className = `${field.className || ''} formly-readonly-field`.trim();
    }

    if (field.type === 'select' && !field.className?.includes('formly-readonly-select')) {
      field.className = `${
        field.className || ''
      } formly-readonly-select`.trim();
    }
    if (field.type === 'select') {
      field.props.tabindex = -1;
    }
  } else {
    if (field.className) {
      field.className = field.className
        .replace(/\bformly-readonly-field\b/g, '')
        .replace(/\bformly-readonly-select\b/g, '')
        .trim();
    }
    if (field.type === 'select' && field.props.tabindex === -1) {
      field.props.tabindex =
        originalTabindex !== undefined ? originalTabindex : 0;
    }
  }
}
